import ChallengesResultBox from './ChallengesResultBox';

export default ChallengesResultBox;
